import { Controller } from "@hotwired/stimulus"

// Attached to a freshly added widget cell (rendered only in the add_widget
// turbo stream): scrolls the new widget into view and briefly highlights it.
export default class extends Controller {
  connect() {
    const reduceMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches
    this.element.scrollIntoView({ behavior: reduceMotion ? "auto" : "smooth", block: "nearest" })

    const card = this.element.firstElementChild
    if (!card) return

    if (!reduceMotion) card.classList.add("widget-enter")
    card.classList.add("ring-2", "ring-emerald-400")
    this.timeout = setTimeout(() => {
      card.classList.remove("ring-2", "ring-emerald-400", "widget-enter")
    }, 1600)
  }

  disconnect() {
    clearTimeout(this.timeout)
  }
}
